import React, { createContext, useContext, useState } from "react";
import { BlocklyPhaserConfig } from "../types/BlocklyTypes";
import { getDefaultConfigPhaser } from "../../Phaser/types/config";
import { getDefaultConfigWorkspace } from "../../Blockly/types/config";

interface ContextValue {
  config: BlocklyPhaserConfig;
  setConfig: React.Dispatch<React.SetStateAction<BlocklyPhaserConfig>>;
}

export const defaultConfig = (admin: boolean = false): BlocklyPhaserConfig => ({
  configPhaser: getDefaultConfigPhaser(),
  configWorkspace: getDefaultConfigWorkspace(admin)
});

const BlocklyConfigContext = createContext<ContextValue>({
  config: defaultConfig(),
  setConfig: () => { }
});

export const ChallengeConfigProvider: React.FC<{ initialConfig?: BlocklyPhaserConfig; children: React.ReactNode }> = ({ initialConfig, children }) => {
  const [config, setConfig] = useState<BlocklyPhaserConfig>(initialConfig || defaultConfig());
  return (
    <BlocklyConfigContext.Provider value={{ config, setConfig }}>
      {children}
    </BlocklyConfigContext.Provider>
  );
};

export const useChallengeConfig = () => useContext(BlocklyConfigContext);
